export default function PHP_file_get_contents() {
  return (
    <div>
      <h1>PHP_file_get_contents</h1>
    </div>
  );
}
